"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The KeyTakeAwayFilter model module.
 * @module model/KeyTakeAwayFilter
 * @version 1.1.3-alpha.1
 */
class KeyTakeAwayFilter {
  /**
   * Constructs a new <code>KeyTakeAwayFilter</code>.
   * @alias module:model/KeyTakeAwayFilter
   */
  constructor() {
    KeyTakeAwayFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>KeyTakeAwayFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/KeyTakeAwayFilter} obj Optional instance to populate.
   * @return {module:model/KeyTakeAwayFilter} The populated <code>KeyTakeAwayFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new KeyTakeAwayFilter();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('media_id')) {
        obj['media_id'] = _ApiClient.default.convertToType(data['media_id'], 'String');
      }
      if (data.hasOwnProperty('q')) {
        obj['q'] = _ApiClient.default.convertToType(data['q'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>KeyTakeAwayFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>KeyTakeAwayFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['media_id'] && !(typeof data['media_id'] === 'string' || data['media_id'] instanceof String)) {
      throw new Error("Expected the field `media_id` to be a primitive type in the JSON string but got " + data['media_id']);
    }
    // ensure the json data is a string
    if (data['q'] && !(typeof data['q'] === 'string' || data['q'] instanceof String)) {
      throw new Error("Expected the field `q` to be a primitive type in the JSON string but got " + data['q']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
KeyTakeAwayFilter.prototype['id'] = undefined;

/**
 * @member {String} media_id
 */
KeyTakeAwayFilter.prototype['media_id'] = undefined;

/**
 * @member {String} q
 */
KeyTakeAwayFilter.prototype['q'] = undefined;
var _default = KeyTakeAwayFilter;
exports.default = _default;